import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; // 👈 necesario para ngIf, ngClass, ngFor
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DraganddropComponent } from './draganddrop.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DndModule } from 'ngx-drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { ColorPickerModule } from 'ngx-color-picker';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    DraganddropComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ColorPickerModule,
    DndModule,
    NgbModule,
    TranslateModule,
    SharedModule,
    RouterModule
  ],
  exports: [
    DraganddropComponent
  ]
})
export class DraganddropModule {}
